import React from 'react';
import PolicyManager from '../PolicyManager';

// 약관 버전 관리
const PRIVACY_POLICY_VERSIONS = {
  'ko': {
    current: '2026.06.04', // 현재 버전
    versions: {
      '2026.06.04': () => import('./versions/ko_20260604.js'),
      '2025.11.19': () => import('./versions/ko_20251119.js'),
    }
  },
  'en': {
    current: '2025.02.01',
    versions: {
      '2025.02.01': () => import('./versions/en_20250201.js'),
    }
  }
};

const PrivacyPolicyManager = ({ language = 'ko', version, onVersionChange }) => {
  return (
    <PolicyManager
      language={language}
      version={version}
      onVersionChange={onVersionChange}
      policyVersions={PRIVACY_POLICY_VERSIONS}
      policyName="PRIVACY"
    />
  );
};

export default PrivacyPolicyManager; 